<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="titlePage mb-3">Histórico de Importações por Requisições</div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <fccTable responsive striped hover :fields="fields" :items="items" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['items'],
  data() {
    return {
      fields: [
        { key: 'id_requisicao', label: 'ID Requisição', active: true },
        { key: 'tipodadoscadastrais', label: 'Tipos de Dados Cadastrais', active: true },
        { key: 'nalteracoes', label: 'Nº de Alterações', active: true },
        { key: 'tecnico', label: 'Técnico', active: true },
        { key: 'datarequisicao', label: 'Data da Requisição', active: true },
        { key: 'descricao', label: 'Status', active: true }
      ]
    }
  }
}
</script>